import React from 'react';
export const PawIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-125">
    <path d="M12 12c-2.5 0-4.5 2-4.5 4.5S9.5 21 12 21s4.5-2 4.5-4.5S14.5 12 12 12z" data-id="element-126" />
    <path d="M7.5 13.5c-1.5 0-2.5-1-2.5-2.5S6 8.5 7.5 8.5 10 9.5 10 11s-1 2.5-2.5 2.5z" data-id="element-127" />
    <path d="M16.5 13.5c1.5 0 2.5-1 2.5-2.5S18 8.5 16.5 8.5 14 9.5 14 11s1 2.5 2.5 2.5z" data-id="element-128" />
    <path d="M12 10.5c-1.5 0-2.5-1-2.5-2.5S10.5 5.5 12 5.5 14.5 6.5 14.5 8s-1 2.5-2.5 2.5z" data-id="element-129" />
  </svg>;
export const ShieldIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-130">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-131" />
  </svg>;
export const LeafIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-132">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-133" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-134" />
  </svg>;
export const ClockIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-135">
    <circle cx="12" cy="12" r="10" data-id="element-136" />
    <polyline points="12 6 12 12 16 14" data-id="element-137" />
  </svg>;
export const FlameIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-138">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" data-id="element-139" />
  </svg>;
export const CheckIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-140">
    <polyline points="20 6 9 17 4 12" data-id="element-141" />
  </svg>;
export const XIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-142">
    <line x1="18" y1="6" x2="6" y2="18" data-id="element-143" />
    <line x1="6" y1="6" x2="18" y2="18" data-id="element-144" />
  </svg>;
export const StarIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-145">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-146" />
  </svg>;
export const ChevronIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-147">
    <polyline points="6 9 12 15 18 9" data-id="element-148" />
  </svg>;
export const BookIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-149">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-150" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" data-id="element-151" />
  </svg>;
export const JournalIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-152">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-153" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" data-id="element-154" />
    <line x1="8" y1="6" x2="16" y2="6" data-id="element-155" />
    <line x1="8" y1="10" x2="16" y2="10" data-id="element-156" />
  </svg>;
export const ListIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-157">
    <line x1="8" y1="6" x2="21" y2="6" data-id="element-158" />
    <line x1="8" y1="12" x2="21" y2="12" data-id="element-159" />
    <line x1="8" y1="18" x2="21" y2="18" data-id="element-160" />
    <line x1="3" y1="6" x2="3.01" y2="6" data-id="element-161" />
    <line x1="3" y1="12" x2="3.01" y2="12" data-id="element-162" />
    <line x1="3" y1="18" x2="3.01" y2="18" data-id="element-163" />
  </svg>;
export const KitchenIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-164">
    <path d="M12 2v20" data-id="element-165" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-166" />
  </svg>;
export const JointIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-167">
    <path d="M18.36 6.64a9 9 0 1 1-12.73 0" data-id="element-168" />
    <line x1="12" y1="2" x2="12" y2="12" data-id="element-169" />
  </svg>;
export const LockIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-170">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-171" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-172" />
  </svg>;
export const BadgeIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-173">
    <path d="M12 15l-2 5-3-1-1-3-5-2 5-2 1-3 3-1 2 5z" data-id="element-174" />
    <circle cx="12" cy="10" r="4" data-id="element-175" />
  </svg>;
export const SparkleIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-176">
    <path d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z" data-id="element-177" />
  </svg>;